import React from "react"
import styled from "styled-components"

const Badge = styled.span`
  cursor: pointer;
  border: 1px solid #e0eef6 !important;
  background-color: #fff !important;
  color: #062c44 !important;
  font-weight: 500 !important;
  display: inline-block !important;
  &:hover,
  &:focus,
  &.active,
  &.badge-active {
    background-color: transparent !important;
    border-color: #ff3e00 !important;
    color: #ff3e00 !important;
  }

  &.badge-active {
    background-color: transparent;
    border-color: #ff3e00;
    color: #ff3e00;
  }
`

const BadgeList = props => {
  const { badgeText, size, badgeColor, ...others } = props
  return (
    <Badge
      className={`badge ${size ? `badge-${size}` : ""} ${
        badgeColor ? `badge-${badgeColor}` : ""
      } `}
      {...others}
    >
      {badgeText}
    </Badge>
  )
}
export default BadgeList
